import TaxCreditProductSection from '../purchases/taxCredit/TaxCreditProductSection';
import ImportProductSection from '../purchases/import/ImportPurchaseSection';
import ExcludedSubjectSection from '../purchases/excludedSubject/ExcludedSubjectSection';
import CreditNoteSection from '../purchases/creditNote/CreditNoteSection';
import DebitNoteSection from '../purchases/debitNote/DebitNoteSection';
import { DOCUMENT_TYPES } from '../../constants/purchase';
import { useBasePurchase } from '../../hooks/purchases/useBasePurchase';

const PurchaseDocumentSection = () => {
  const { activeDocumentType } = useBasePurchase();

  switch (activeDocumentType?.id) {
    case DOCUMENT_TYPES.TAX_CREDIT:
      return <TaxCreditProductSection />;

    case DOCUMENT_TYPES.IMPORT:
      return <ImportProductSection />;

    case DOCUMENT_TYPES.EXCLUDED_SUBJECT:
      return <ExcludedSubjectSection />;

    case DOCUMENT_TYPES.CREDIT_NOTE:
      return <CreditNoteSection />;

    case DOCUMENT_TYPES.DEBIT_NOTE:
      return <DebitNoteSection />;

    default:
      return null;
  }
};

export default PurchaseDocumentSection;
